import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofz22V3 } from './pages'

type TIdToPageMapWoofz22V3 = Record<PageIdWoofz22V3, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ22V3: TIdToPageMapWoofz22V3 = {
  [PageId.DOG_AGE_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/DogAgeQuestion22V3'
      ).then((m) => ({
        default: m.DogAgeQuestion22V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/DogAgeQuestion22V3'),
  },
  [PageId.SEX_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/questions/SexQuestion22V3').then(
        (m) => ({
          default: m.SexQuestion22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/SexQuestion22V3'),
  },
  [PageId.DOG_BREED_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-breed/DogBreedQuestion22V3'
      ).then((m) => ({
        default: m.DogBreedQuestion22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-breed/DogBreedQuestion22V3'
      ),
  },
  [PageId.DOG_BREED_ID_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-breed/breed-id/BreedPhotoScreen22V3'
      ).then((m) => ({
        default: m.BreedPhotoScreen22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-breed/breed-id/BreedPhotoScreen22V3'
      ),
  },
  [PageId.URGE_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/questions/UrgePage22V3').then(
        (m) => ({
          default: m.UrgePage22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/UrgePage22V3'),
  },
  [PageId.COMMANDS_61_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant61_22V3'
      ).then((m) => ({
        default: m.CommandsVariant6122V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant61_22V3'),
  },
  [PageId.COMMANDS_62_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant62_22V3'
      ).then((m) => ({
        default: m.CommandsVariant6222V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant62_22V3'),
  },
  [PageId.COMMANDS_63_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant63_22V3'
      ).then((m) => ({
        default: m.CommandsVariant6322V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/CommandsVariant63_22V3'),
  },
  [PageId.POTTY_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/questions/PottyQuestion22V3').then(
        (m) => ({
          default: m.PottyQuestion22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/PottyQuestion22V3'),
  },
  [PageId.BEHAVIOR_2_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/BehaviorQuestion2_22V3'
      ).then((m) => ({
        default: m.BehaviorQuestion2nd22V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/BehaviorQuestion2_22V3'),
  },
  [PageId.TRAINING_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/TrainingQuestion22V3'
      ).then((m) => ({
        default: m.TrainingQuestion22V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/TrainingQuestion22V3'),
  },
  [PageId.URGE_2_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/questions/UrgePage2_22V3').then(
        (m) => ({
          default: m.UrgePage222V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/questions/UrgePage2_22V3'),
  },
  [PageId.PREPARE_FLOW_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/prepare-flow/PrepareFlow22V3'
      ).then((m) => ({
        default: m.PrepareFlow22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/prepare-flow/PrepareFlow22V3'
      ),
  },
  [PageId.DOG_STATISTICS_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-statistics/DogStatistics22V3'
      ).then((m) => ({
        default: m.DogStatistics22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/questions/dog-statistics/DogStatistics22V3'
      ),
  },
  [PageId.EMAIL_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/email/Email22V3').then((m) => ({
        default: m.Email22V3,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v3/pages/email/Email22V3'),
  },
  [PageId.NEWSLETTER_URGE_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/email/components/NewsletterUrge'
      ).then((m) => ({
        default: m.NewsletterUrge,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/email/components/NewsletterUrge'),
  },
  [PageId.LAST_CHANCE_OFFER_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/last-chance-offer/LastChanceOfferPage22V3'
      ).then((m) => ({
        default: m.LastChanceOfferPage22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/last-chance-offer/LastChanceOfferPage22V3'
      ),
  },
  [PageId.SUBSCRIPTIONS_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/subscriptions/SubscriptionsPage22V3'
      ).then((m) => ({
        default: m.SubscriptionsPage22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/subscriptions/SubscriptionsPage22V3'
      ),
  },
  [PageId.PAYMENT_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/payment/PaymentPage22V3').then(
        (m) => ({
          default: m.PaymentPage22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/payment/PaymentPage22V3'),
  },
  [PageId.LAST_CHANCE_OFFER_2_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/last-chance-offer/LastChanceOfferPage2_22V3'
      ).then((m) => ({
        default: m.LastChanceOfferPage2_22V3,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz22_v3/pages/last-chance-offer/LastChanceOfferPage2_22V3'
      ),
  },
  [PageId.CANCEL_OFFER_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/subscriptions/CancelOffer22V3'
      ).then((m) => ({
        default: m.CancelOffer22V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/subscriptions/CancelOffer22V3'),
  },
  [PageId.CHAT_UPSELL_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/ChatUpsell22V3').then(
        (m) => ({
          default: m.ChatUpsell22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/ChatUpsell22V3'),
  },
  [PageId.UPSELL_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/Upsell22V3').then((m) => ({
        default: m.Upsell22V3,
      })),
    ),
    preload: () => import('nove8/cohorts/woofz22_v3/pages/upsell/Upsell22V3'),
  },
  [PageId.UPSELL_FEEDING_GUIDE_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/FeedingGuideUpsell').then(
        (m) => ({
          default: m.FeedingGuideUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/FeedingGuideUpsell'),
  },
  [PageId.UPSELL_EMOTIONAL_SUPPORT_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/upsell/EmotionalSupportUpsell'
      ).then((m) => ({
        default: m.EmotionalSupportUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/EmotionalSupportUpsell'),
  },
  [PageId.UPSELL_PITPAT_22V3]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/UpsellPitpat22V3').then(
        (m) => ({
          default: m.UpsellPitpat22V3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/upsell/UpsellPitpat22V3'),
  },
  [PageId.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageId.DOWNLOAD_22V3]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz22_v3/pages/download-app/DownloadApp22V3'
      ).then((m) => ({
        default: m.DownloadApp22V3,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/woofz22_v3/pages/download-app/DownloadApp22V3'),
  },
}
